import { FormControl, Autocomplete, Grid, TextField } from "@mui/material";

export function HODDepartmentSelect({ handleSelect, hodList, errors }) {
  return (
    <FormControl required fullWidth>
      <Autocomplete
        id="grouped-hod-department-select-sample-request-details-autocomplete"
        onChange={(e, newValue) =>
          handleSelect("HODDepartmentSelect", newValue.department)
        }
        loading={true}
        options={hodList}
        groupBy={(option) => option.department}
        getOptionLabel={(option) =>
          `${option.department}: ${option.name} (${option.email})`
        }
        fullWidth
        renderOption={(props, option) => (
          <Grid {...props} container ml={3} mb={2}>
            <Grid item xs={12}>
              {option.name}
            </Grid>
            <Grid item xs={12}>
              <small>{option.position}</small>
            </Grid>
            <Grid item xs={12}>
              <small>{option.email}</small>
            </Grid>
          </Grid>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label="HOD Email"
            error={errors && errors.HODDepartment && true}
            helperText={
              errors && errors.HODDepartment !== "" ? errors.HODDepartment : ""
            }
          />
        )}
      />
    </FormControl>
  );
}
